<template>
  <div>
    <LineUpLoader v-if="loading" />
    <v-layout row wrap>
      <v-flex xs12 pa-2 class="text-xs-center">
        <span class="display-1">{{ groupTitle }}</span>
      </v-flex>
      <v-flex v-for="{ title, items } of group" :key="title" xs12 md3 lg4 pa-2>
        <line-up-list
          :items="items"
          :title="title"
          :team-id="teamId"
          :match-id="matchId"
          :team-type="teamType"
          :actions="actions"
          :edit="edit"
          @setLineUp="(value) => $emit('setLineUp', value)"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import LineUpList from './LineUpList'
import LineUpLoader from '@/components/widgets/loading/LineUpLoader'
export default {
  name: 'LineUpListGroup',
  components: {
    LineUpList,
    LineUpLoader,
  },
  props: {
    groupTitle: {
      type: String,
      required: true,
      default: '',
    },
    group: {
      type: Array,
      required: true,
      default: () => [],
    },
    teamId: {
      type: String,
      required: true,
      default: '',
    },
    matchId: {
      type: String,
      required: false,
      default: '',
    },
    teamType: {
      type: String,
      required: false,
      default: 'home',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>
